export default "__VITE_ASSET__lxkfych1__"